import React          from 'react';
import ReactDom       from 'react-dom';
import Moment         from 'moment';

import Const          from 'fw_const';
import Utils          from 'utils';

import ContentsModal  from 'contents_modal';

// -------------------------------------------------------

const API_COUNT = 10;

class RegisterModal extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
    
    this.timer;
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      is_api            : false,
      is_active         : false,
      api_accounts      : [],
      api_progress      : 0,
      api_loading       : false,
      loading_percent   : 0,
      complete_accounts : [],
      complete_modal    : false,
    };
  }
  // -------------------------------------------------------
  
  submit() {
    let accounts = [];
    this.accounts.value.split(/,| |\n|\r/).map((id) => {
      try {
        id = id.split(/\?/)[0];
        id = id.replace('https://www.instagram.com/','').replace('https://instagram.com/','').replace('www.instagram.com','');
        id = id.replace(/"|'|\/|,|@/ig, '');
        id = toHalfWidth(id);
        if( id != '' && accounts.indexOf(id) == -1 ) accounts.push(id);
      } catch(e) {}
    });
    
    let api_accounts = [];
    for( let i = 0; i <= Math.floor(accounts.length / API_COUNT); i++ ){
      let ids = [];
      accounts.map((id, key) => { if( key >= (i * API_COUNT) && key < ((i + 1) * API_COUNT)) ids.push(id); });
      api_accounts.push(ids);
    };
    
    // 人数オーバー
    if( accounts.length > 100 ){
      alert('一度に登録が可能なアカウント数は100件までです');
      return;
    }
    
    // API通信処理
    this.setState({ api_accounts: api_accounts, api_progress: 0, api_loading: true, loading_percent: 0, complete_accounts: [] });
    
    setTimeout( function(){
      this.sendAPI.bind(this)();
      this.timer = setInterval(function(){
        this.sendAPI.bind(this)();
      }.bind(this), 1000);
    }.bind(this), 50);
  }
  // -------------------------------------------------------
  
  change() {
    this.setState({ is_active: (this.accounts.value == '') ? false : true });
  }
  // -------------------------------------------------------
  
  sendAPI() {
    if( this.state.is_api == true ) return;
    
    let register_ids = this.state.api_accounts[this.state.api_progress];
    if( register_ids == undefined || register_ids.length == 0 ){
      this.completeAPI.bind(this)();
      return;
    }
    
    Utils.request.bind(this)('/api/influencer/register', { register_ids: register_ids, register_mode: this.props.register_mode, project: this.props.project },
      function(res){
        
        let complete_accounts = this.state.complete_accounts;
        res.body.data.map((d) => { complete_accounts.push(d); });
        
        let progress = (this.state.api_progress + 1);
        this.setState({ is_api: false, api_progress: progress, complete_accounts: complete_accounts, loading_percent: Math.round((progress / this.state.api_accounts.length) * 100) });
        this.toggleModal.bind(this)(true);
        
      }.bind(this),
      function(res){
        
        alert('登録エラーが発生しました');
        this.completeAPI.bind(this)();
        
      }.bind(this), false
    );
    
    this.setState({ is_api: true });
  }
  // -------------------------------------------------------
  
  completeAPI() {
    clearTimeout(this.timer);
    this.setState({ api_accounts: [], api_loading: false });
  }
  // -------------------------------------------------------
  
  /*
   * データ編集
   */
  toggleModal(flg) {
    this.setState({ complete_modal: flg });
    
    if( flg == true  ) Utils.fixedContents();
    if( flg == false ) Utils.unlockFixedContents();
    
    if( flg == false ) this.props.close_ev.bind(this)(false);
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    if( data == undefined ) data = {};
    
    let base = this.props.base;
    
    return (
      <ContentsModal
        view      = {this.props.view}
        width     = {400}
        height    = {300}
        close_ev  = {this.props.close_ev.bind(this, false)}
        html      = {
          <div className="modal-item influencer-register-modal">
            <h3 className="search-result">アカウントの登録</h3>
            
            <textarea className="text" ref={(input) => { this.accounts = input }} onChange={this.change.bind(this)} placeholder="アカウントIDを入力してください" />
            <h6>※複数設定する場合は、カンマ・改行・スペースの形式で入力してください</h6>
            
            { (this.state.is_active == true)
              ? <div className="button" onClick={this.submit.bind(this)}>登録</div>
              : <div className="button off">登録</div>
            }
            
            { (this.state.api_loading == true) &&
              <div className="influencer-register-bg">
                <div className="influencer-register-item">
                  <div className="sk-circle">
                    <div className="sk-circle1 sk-child"></div>
                    <div className="sk-circle2 sk-child"></div>
                    <div className="sk-circle3 sk-child"></div>
                    <div className="sk-circle4 sk-child"></div>
                    <div className="sk-circle5 sk-child"></div>
                    <div className="sk-circle6 sk-child"></div>
                    <div className="sk-circle7 sk-child"></div>
                    <div className="sk-circle8 sk-child"></div>
                    <div className="sk-circle9 sk-child"></div>
                    <div className="sk-circle10 sk-child"></div>
                    <div className="sk-circle11 sk-child"></div>
                    <div className="sk-circle12 sk-child"></div>
                  </div>
                  
                  {Utils.viewInt(this.state.loading_percent)}%
                </div>
                
                <div className="button no" onClick={this.completeAPI.bind(this)}>中断</div>
              </div>
            }
            
            <CompleteModal view={this.state.complete_modal} register_mode={this.props.register_mode} complete_accounts={this.state.complete_accounts} close_ev={this.toggleModal.bind(this)} />
          </div>
        }
      />
    );
  }
}
// -------------------------------------------------------

class CompleteModal extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      event : {},
      upload_url : '',
    }
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let register_mode = this.props.register_mode;
    
    // 通常登録パターン
    let score = {
      register : { id: 'register', name: '新規登録', count: 0 },
      existing : { id: 'existing', name: '登録済み', count: 0 },
      error    : { id: 'error',    name: 'エラー',   count: 0 },
    };
    this.props.complete_accounts.map((d) => { score[d.type].count += 1; });
    
    // ワークフロー登録パターン
    if( register_mode == 'workflow' ){
      score = {
        register : { id: 'register', name: '登録完了', count: 0 },
        error    : { id: 'error',    name: 'エラー',   count: 0 },
      };
      this.props.complete_accounts.map((d) => {
        if( score[d.type] != undefined ) score[d.type].count += 1; 
        if( d.type == 'existing' ) score['register'].count += 1;
      });
    }
    
    let scoreList = Utils.createObjectToArray(score);
    
    let box_height = 490;
    if( score.register.count > 0 ) box_height += 20;
    if( score.error.count > 0 ) box_height += 50;
    
    return (
      <ContentsModal
        view      = {this.props.view}
        width     = {800}
        height    = {box_height}
        close_ev  = {this.props.close_ev.bind(this, false)}
        html      = {
          <div className="modal-item complete-modal">
            <h2>登録結果</h2>
            <ul>
              { this.props.complete_accounts.map((d, key) => {
                let type_name = '';
                if( d.type == 'register' ) type_name = '新規登録しました！';
                if( d.type == 'existing' ) type_name = '既に登録済みです';
                if( d.type == 'error'    ) type_name = 'アカウントが存在しない もしくは ビジネスアカウントではありません';
                
                if( register_mode == 'workflow' ){
                  if( d.type == 'existing' ) d.type = 'register';
                  if( d.type == 'register' ) type_name = 'ワークフローに登録しました！';
                }
                
                return (
                  <li key={key}>
                    <div className={'mark type_bg_'+ d.type} />
                    {( d.type == 'error')
                      ? <div className="insta-id error-url"><a href={'https://www.instagram.com/'+ d.insta_id} target="_blank">@{d.insta_id}</a></div>
                      : <div className="insta-id">@{d.insta_id}</div>
                    }
                    <div className={'type type_font_'+ d.type}>{type_name}</div>
                  </li>
                );
              })}
            </ul>
            <div className="score">
              { scoreList.map((d, key) => {
                return (
                  <div key={key} className="score-item">
                    <p className={'type type_bg_'+ d.id} />
                    <p className={'font type_font_'+ d.id}>{d.name}</p>
                    <p className="count">{d.count}</p>
                  </div>
                );
              })}
            </div>
            
            <div className="button" onClick={this.props.close_ev.bind(this, false)}>閉じる</div>
            { (score.register.count > 0) && <h5 className="error">※新規登録したアカウントの反映には少々時間が掛かる可能性がございます。ご了承ください</h5> }
            { (score.error.count > 0) && <h5 className="error">※エラーになったアカウントは裏で確認します。ビジネスアカウント以外で存在する場合は登録しますのでお待ち下さい。<br />（アカウントIDにスペルの誤りが無いかIDをクリックしてご確認ください）</h5> }
            
          </div>
        }
      />
    );
  }
}
// -------------------------------------------------------

function toHalfWidth(str) {
  str = str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) { return String.fromCharCode(s.charCodeAt(0) - 0xFEE0); });
  return str;
}
// -------------------------------------------------------

// レンダリング処理
export default RegisterModal;